export const replaceNullishValues = (
  obj: Record<string, unknown>,
  defaultValues: Record<string, unknown>
) => {
  const newObj = { ...defaultValues, ...obj }
  Object.entries(newObj).forEach(([key, value]) => {
    if (value === null || value === undefined) {
      newObj[key] = defaultValues[key]
    } else if (typeof value === 'object' && !Array.isArray(value)) {
      newObj[key] = replaceNullishValues(
        value as Record<string, unknown>,
        defaultValues[key] as Record<string, unknown>
      )
    }
  })
  return newObj
}

if (import.meta.vitest) {
  const { it, expect } = import.meta.vitest
  const defaultValues = {
    a: 1,
    b: 2,
    c: {
      d: 3,
      e: 4,
      f: {
        g: 5,
        h: 6,
      },
    },
  }
  it.each([
    {
      defaultValues,
      expected: {
        a: 2,
        b: 2,
        c: {
          d: 3,
          e: 4,
          f: {
            g: 5,
            h: 6,
          },
        },
      },
      obj: {
        a: 2,
        b: undefined,
        c: {
          d: null,
          e: undefined,
          f: {
            g: null,
            h: undefined,
          },
        },
      },
    },
    {
      defaultValues,
      expected: {
        a: 2,
        b: 3,
        c: {
          d: 3,
          e: 4,
          f: {
            g: 5,
            h: 6,
          },
        },
      },
      obj: {
        a: 2,
        b: 3,
        c: {
          d: null,
          e: undefined,
          f: {
            g: null,
            h: undefined,
          },
        },
      },
    },
    {
      defaultValues,
      expected: {
        a: 1,
        b: 2,
        c: {
          d: 3,
          e: 4,
          f: {
            g: 5,
            h: 6,
          },
        },
      },
      obj: null,
    },
    {
      defaultValues,
      expected: {
        a: 1,
        b: 2,
        c: {
          d: 3,
          e: 4,
          f: {
            g: 5,
            h: 6,
          },
        },
      },
      obj: undefined,
    },
    {
      defaultValues,
      expected: {
        a: 1,
        b: 2,
        c: {
          d: 3,
          e: 4,
          f: {
            g: 5,
            h: 6,
          },
        },
      },
      obj: {},
    },
  ])(`replaceNullishValues(%o,%o)`, ({ defaultValues, expected, obj }) => {
    //@ts-ignore
    const result = replaceNullishValues(obj, defaultValues)
    expect(result).toEqual(expected)
  })
}
